module.exports = __webpack_public_path__ + "static/media/orchard-2.11088a66.png";